export default __webpack_public_path__ + "static/media/gsi-logo@2x.07594523.png";